"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayToMap = exports.hasMoreThen1Element = exports.hasMoreThenNElements = exports.insertIf = void 0;
const insertIf = (condition, ...elements) => (condition ? elements : []);
exports.insertIf = insertIf;
const hasMoreThenNElements = (array, n) => (array !== null && array !== void 0 ? array : []).length > n;
exports.hasMoreThenNElements = hasMoreThenNElements;
const hasMoreThen1Element = (array) => (0, exports.hasMoreThenNElements)(array, 1);
exports.hasMoreThen1Element = hasMoreThen1Element;
const arrayToMap = (key, array) => new Map(array === null || array === void 0 ? void 0 : array.map((a) => [`${a[key]}`, a]));
exports.arrayToMap = arrayToMap;
